import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteEventRegistration } from "actions/action";
import { getEventRegistrationInfo } from "actions/action";
import { imageBaseURL } from "actions/Base_URL";
import { getInvRegistrationInfo } from "actions/action";
import { deleteInvRegistration } from "actions/action";

const ViewInvRegistration = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate()
  const { invId } = location.state;
  const userId = localStorage.getItem("user_id");
  const [formData, setFormData] = useState({
    id: "",
    labId: "",
    data: null
  });

  const fetchFormData = async () => {
    try {
      const response = await getInvRegistrationInfo(invId, userId);
      if (response.status !== 404) {
        const data = response.data;
        setFormData({
          ...formData, data: {
            issued_date: new Date(data.issued_date).toLocaleDateString(),
            receiving_date: new Date(data.receiving_date).toLocaleDateString(),
            quantity: data.quantity || 1,
            status: data.status

          }, id: data.registration_id, labId: data.inventory.lab_id
        });
      }

    } catch (err) {
      console.log(err);

    }
  }

  const handleDeleteEventRegistration = async (id, labId) => {
    try {
      const getApiResponse = await deleteInvRegistration(id);
      if (getApiResponse.status == 200) {
        navigate(`/student/inventory/labs/${labId}`);
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  }
  useEffect(() => {
    fetchFormData();
  }, [])
  return (
    <div className="relative">
      <div className="flex justify-between items-center px-4 mt-6">
        <div>
          <h2 className="font-bold text-2xl text-white mb-1">Registration Details</h2>
          <p className="text-blueGray-300 text-sm">View the status and details of your inventory request</p>
        </div>
        <div className="flex items-center gap-3">
          <Tooltip title="Go Back" arrow>
            <button
              className="bg-blueGray-700 text-white active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none transition-all duration-150"
              type="button"
              onClick={() => navigate(-1)}
            >
              <i className="fas fa-arrow-left mr-2"></i> Back
            </button>
          </Tooltip>
          {formData.id && (
            <Tooltip title="Delete Request" arrow>
              <button
                type="button"
                className="bg-red-500 text-white active:bg-red-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none transition-all duration-150"
                onClick={() => handleDeleteEventRegistration(formData.id, formData.labId)}
              >
                <FontAwesomeIcon icon={faTrash} className="mr-2" /> Delete
              </button>
            </Tooltip>
          )}
        </div>
      </div>

      <div className="mt-8 px-4 lg:px-6">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-xl rounded-xl bg-blueGray-700 border border-blueGray-600 overflow-hidden">
          <div className="flex-auto p-6 lg:p-10">
            {formData.data ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Information Sections */}
                <div className="space-y-6">
                  <div className="border-b border-blueGray-600 pb-4">
                    <h3 className="text-white font-semibold text-lg flex items-center">
                      <i className="fas fa-info-circle mr-2 text-blue-400"></i> General Information
                    </h3>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex flex-col">
                      <span className="text-blueGray-400 text-xs font-bold uppercase mb-1">Registration ID</span>
                      <span className="text-white font-medium text-sm">#{formData.id}</span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-blueGray-400 text-xs font-bold uppercase mb-1">Quantity Requested</span>
                      <span className="text-white font-medium text-sm">{formData.data.quantity} Units</span>
                    </div>

                    <div className="flex flex-col">
                      <span className="text-blueGray-400 text-xs font-bold uppercase mb-1">Current Status</span>
                      <div className="mt-1">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase ${
                          formData.data.status === 'issued' ? 'bg-blue-500/20 text-blue-400 border border-blue-500/50' :
                          formData.data.status === 'received' ? 'bg-green-500/20 text-green-400 border border-green-500/50' :
                          formData.data.status === 'pending' ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/50' :
                          'bg-red-500/20 text-red-400 border border-red-500/50'
                        }`}>
                          <i className={`fas ${
                            formData.data.status === 'issued' ? 'fa-check-circle' :
                            formData.data.status === 'received' ? 'fa-check-double' :
                            formData.data.status === 'pending' ? 'fa-clock' :
                            'fa-times-circle'
                          } mr-2`}></i>
                          {formData.data.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="border-b border-blueGray-600 pb-4">
                    <h3 className="text-white font-semibold text-lg flex items-center">
                      <i className="fas fa-calendar-alt mr-2 text-blue-400"></i> Schedule Details
                    </h3>
                  </div>

                  <div className="space-y-4">
                    <div className="flex flex-col p-4 bg-blueGray-800 rounded-lg border border-blueGray-600 hover:border-blue-500/50 transition-all duration-200">
                      <span className="text-blueGray-400 text-xs font-bold uppercase mb-1">Request Date</span>
                      <span className="text-white font-semibold text-base">{formData.data.issued_date}</span>
                    </div>

                    <div className="flex flex-col p-4 bg-blueGray-800 rounded-lg border border-blueGray-600 hover:border-blue-500/50 transition-all duration-200">
                      <span className="text-blueGray-400 text-xs font-bold uppercase mb-1">Tentative Return Date</span>
                      <span className="text-white font-semibold text-base">{formData.data.receiving_date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-20 text-center">
                <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mb-4 mt-4">
                  <i className="fas fa-exclamation-triangle text-red-500 text-3xl"></i>
                </div>
                <h3 className="text-white text-xl font-bold mb-2">No Registration Found</h3>
                <p className="text-blueGray-400 max-w-xs mx-auto">
                  You haven't registered for this inventory item yet. Please submit a request first.
                </p>
                <button
                  onClick={() => navigate(-1)}
                  className="mt-6 bg-blue-500 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-600 transition-all duration-200"
                >
                  Return to Inventory
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewInvRegistration;
